import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatchPassword, PasswordValidator } from '../../utils/form-validators.util';
import { SectionState } from '@shared-features/enums/layout.enum';
import { UserType } from '@shared-features/enums/shared-enums.enum';
import { Observable } from 'rxjs';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { UserApi } from '@shared-features/services';

@Component({
  selector: 'app-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.scss'],
})
export class ResetPasswordModalComponent extends BaseComponent implements OnInit {
  public displayPassword = false;
  public displayConfirmPassword = false;

  @ViewChild('resetPasswordModal') resetPasswordModal;
  @Input() id: number;
  @Input() name: string;
  @Input() showModal: Observable<void>;
  @Output() closeModal = new EventEmitter();

  form: FormGroup;
  sectionState: SectionState;

  constructor(private formBuilder: FormBuilder, private userApi: UserApi) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.showModal.subscribe((value: any) => {
      if (value) this.resetPasswordModal.showModal();
    });
  }

  initForm() {
    this.form = this.formBuilder.group(
      {
        password: new FormControl('', [Validators.required, PasswordValidator]),
        confirmPassword: new FormControl('', [Validators.required, PasswordValidator]),
      },
      { validator: MatchPassword }
    );
  }

  onCancelClicked() {
    this.closeModal.emit();
    this.resetPasswordModal.closeModal();
    this.form.reset();
  }

  onSendClicked() {
    this.load(this.userApi.resetPassword(this.id, UserType.DRIVER, this.form.value['password']), {
      isLoadingTransparent: true,
    }).subscribe(
      () => {
        this.asyncFeedbackService.showSuccessMessage(
          this.translate('SuccessMessages.PasswordResetSuccessfully')
        );
        this.onCancelClicked();
      },
      (error) => {
        this.onCancelClicked();
        this.asyncFeedbackService.showFailureMessage(
          error ? error.errors[0] : this.translate('ErrorMessages.ErrorHappened')
        );
      }
    );
  }
}
